export class MonetaryArea {
  reference: string;
  name: string;
  currencyLongName: string;
  currencyShortName: string;
  currencyCode: string;


  constructor(reference: string = null,
              name: string = null,
              currencyLongName: string = null,
              currencyShortName: string  = null,
              currencyCode: string = null) {
    this.reference = reference;
    this.name = name;
    this.currencyLongName = currencyLongName;
    this.currencyShortName = currencyShortName;
    this.currencyCode = currencyCode;
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/parameters/monetary-areas/monetary-area.model.ts